var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Danh sách người nhận ",
        visible: _vm.dialogVisible,
        width: "70%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "hr" }, [_c("hr")]),
      _c(
        "div",
        { staticClass: "table-content row-data" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                data: _vm.historyappsend,
                "highlight-current-row": "",
                "header-cell-style": _vm.tableHeaderColor,
                "max-height": _vm.$tableMaxHeight,
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "STT",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reiceiverName",
                  label: "Tên người nhận",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "Số điện thoại",
                  align: "center ",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "content",
                  label: "Nội dung gửi đi ",
                  align: "center ",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Trạng thái", align: "center", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.receiverStatus === 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "small" } },
                              [_vm._v("Đang gửi")]
                            )
                          : scope.row.receiverStatus === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "small" } },
                              [_vm._v("Đã gửi")]
                            )
                          : scope.row.receiverStatus === 2
                          ? _c(
                              "el-tag",
                              { attrs: { type: "danger", size: "small" } },
                              [_vm._v("Thất bại")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "small" } },
                              [_vm._v("Đang gửi")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btt" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogByButton("newBrand")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v("Đóng")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }